import { render, staticRenderFns } from "./ProjectPricelists.vue?vue&type=template&id=4a391d9e&scoped=true"
import script from "./ProjectPricelists.vue?vue&type=script&lang=js"
export * from "./ProjectPricelists.vue?vue&type=script&lang=js"
import style0 from "./ProjectPricelists.vue?vue&type=style&index=0&id=4a391d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a391d9e",
  null
  
)

export default component.exports